import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

/**
 * @file Dialog - hook
 * @author alfielv
 */
import _ from 'lodash';
import React, { useState, useMemo, useCallback, useRef } from 'react';
import Dialog from '../../components/Dialog';
import Drawer from '../../components/Drawer';
import useForceUpdate from '../useForceUpdate';
var DESTROY_DELAY = 500; // 隐藏到真正销毁间的延时

export default (function (props) {
  var _ref = props || {},
      $onShow = _ref.$onShow,
      $onHide = _ref.$onHide;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  var dialogOptionsRef = useRef(null);
  var forceUpdate = useForceUpdate();
  var showDialog = useCallback(function () {
    var dialogOptions = dialogOptionsRef.current;
    setShow(true);
    $onShow === null || $onShow === void 0 ? void 0 : $onShow(dialogOptions);
  }, [$onShow]);
  var hideDialog = useCallback(function () {
    var dialogOptions = dialogOptionsRef.current;
    setShow(false);
    $onHide === null || $onHide === void 0 ? void 0 : $onHide(dialogOptions);
    setTimeout(function () {
      return dialogOptionsRef.current = null;
    }, DESTROY_DELAY);
  }, [$onHide]);
  var setDialogOptions = useCallback(function (dialogOptions) {
    dialogOptionsRef.current = dialogOptions;
    showDialog();
    forceUpdate();
  }, [forceUpdate, showDialog]); // eslint-disable-next-line @typescript-eslint/naming-convention

  var DialogComponent = useMemo(function () {
    var dialogOptions = dialogOptionsRef.current;

    if (_.isNull(dialogOptions)) {
      return null;
    }

    var type = dialogOptions.type,
        dialogComponentOptions = _objectWithoutProperties(dialogOptions, ["type"]);

    if (type === 'drawer') {
      return /*#__PURE__*/React.createElement(Drawer, {
        dialogOptions: dialogComponentOptions,
        show: show,
        showDialog: showDialog,
        hideDialog: hideDialog
      });
    }

    return /*#__PURE__*/React.createElement(Dialog, {
      dialogOptions: dialogComponentOptions,
      show: show,
      showDialog: showDialog,
      hideDialog: hideDialog
    });
  }, [show, showDialog, hideDialog]);
  return {
    Dialog: DialogComponent,
    showDialog: showDialog,
    hideDialog: hideDialog,
    setDialogOptions: setDialogOptions
  };
});